// src/components/IngredientSearch.jsx
import React from 'react';

export default function IngredientSearch({ value, onChange }) {
  return (
    <div style={styles.wrap}>
      <span style={styles.icon}>⌕</span>
      <input
        type="text"
        placeholder="Search ingredients…"
        value={value}
        onChange={e => onChange(e.target.value)}
        style={styles.input}
      />
      {value && (
        <button style={styles.clear} onClick={() => onChange('')}>×</button>
      )}
    </div>
  );
}

const styles = {
  wrap: {
    position: 'relative',
    marginBottom: '14px',
  },
  icon: {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '18px',
    color: 'var(--text-muted)',
    pointerEvents: 'none',
    lineHeight: 1,
  },
  input: {
    width: '100%',
    padding: '10px 36px 10px 36px',
    border: '1.5px solid var(--border-base)',
    borderRadius: 'var(--radius-md)',
    background: 'var(--bg-input)',
    fontFamily: "'Outfit', sans-serif",
    fontSize: '13.5px',
    color: 'var(--text-primary)',
    outline: 'none',
    transition: 'border-color var(--transition), background var(--transition)',
  },
  clear: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    color: 'var(--text-muted)',
    fontSize: '18px',
    cursor: 'pointer',
    lineHeight: 1,
    padding: '2px 4px',
  },
};
